module.exports = __webpack_public_path__ + "static/img/6.f45b054.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/99/zh/6.png
// module id = 6k/Q
// module chunks = 0